import { ReactNode } from 'react';
import styles from './LoadingOverlay.module.css';
import { ProgressBar } from '../../../components/ui/ProgressBar/ProgressBar';
import logoImage from '../../../assets/images/logo-light.png';

interface IOverlayProps {
  children?: ReactNode;
}

export const LoadingOverlay = ({ children }: IOverlayProps) => {
  return (
    <div className={styles.loadingContainer}>
      <div>
        <div className={styles.logoContainer}>
          <img src={logoImage} alt="" />
        </div>
        <ProgressBar
          className="m-0 mt-2"
          bgClass={styles.loadingProgressBg}
          barClass={styles.loadingProgressBar}
        />
        {children}
      </div>
    </div>
  );
};
